import {fetchDataFromApi} from './apiHelper';

export const fetchDailyStatisticFields = () => fetchDataFromApi('post', '/api/xml/daily/statistic');